import React from "react";
import { Input, InputProps } from "antd";

const { TextArea } = Input;
interface TextAreasProps extends InputProps {
  title?: string;
  className?: string;
  placeholder?: string;
  value?: string;
  disabled?: boolean;
  onChange?: (value: any) => void; // Add an onChange callback
  style?: React.CSSProperties;
  required?: boolean;
  toggle?: React.ReactNode;
}
const TextAreas = ({
  value,
  title,
  disabled = false,
  className = "",
  onChange = () => {},
  style,
  required,
  toggle,
}: TextAreasProps) => (
  <>
    {/* {title && (
      <label
        style={{
          color: "#557EFF",
          fontSize: "14px",
          fontWeight: "500",
          margin: "10px 0px ",
          marginBottom: "12px",
          display: "block",
        }}
      >
        {title}
      </label>
    )} */}
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-start",
        marginBottom: "10px",
      }}
    >
      {title && (
        <label
          style={{
            color: "#557EFF",
            fontSize: "14px",
            fontWeight: "500",
            display: "block",
          }}
        >
          {title}
          {"  "}
          {required && (
            <div
              style={{
                transform: "scale(1.5) translateX(3px)",
              }}
            >
              *
            </div>
          )}
        </label>
      )}{" "}
      {toggle && toggle}
    </div>
    <TextArea
      rows={4}
      disabled={disabled}
      className={className}
      placeholder="Start typing..."
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={style}
    />
  </>
);

export default TextAreas;
